/* VP Cycling — minimal theme JS.
   Handles: mobile drawer, PDP variant switching, PDP qty control, PDP gallery. */

(function () {
  'use strict';

  /* ---------- Mobile drawer ---------- */
  const drawer = document.querySelector('[data-drawer]');
  const backdrop = document.querySelector('[data-drawer-backdrop]');
  const openBtns = document.querySelectorAll('[data-drawer-open]');
  const closeBtns = document.querySelectorAll('[data-drawer-close]');
  function openDrawer() { drawer?.classList.add('open'); backdrop?.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { drawer?.classList.remove('open'); backdrop?.classList.remove('open'); document.body.style.overflow = ''; }
  openBtns.forEach(b => b.addEventListener('click', openDrawer));
  closeBtns.forEach(b => b.addEventListener('click', closeDrawer));
  backdrop?.addEventListener('click', closeDrawer);

  /* ---------- PDP gallery ---------- */
  document.querySelectorAll('[data-pdp-gallery]').forEach(gallery => {
    const hero = gallery.querySelector('[data-pdp-hero] img');
    gallery.querySelectorAll('[data-pdp-thumb]').forEach(thumb => {
      thumb.addEventListener('click', () => {
        const src = thumb.getAttribute('data-src');
        if (src && hero) hero.src = src;
        gallery.querySelectorAll('[data-pdp-thumb]').forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
      });
    });
  });

  /* ---------- PDP qty ---------- */
  document.querySelectorAll('[data-qty]').forEach(q => {
    const input = q.querySelector('input');
    q.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    q.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  });

  /* ---------- PDP variant selection ----------
     Shopify variant resolution: for each option index, collect active picks,
     then find the matching variant by comparing option1/option2/option3. */
  document.querySelectorAll('[data-variant-form-wrapper]').forEach(wrapper => {
    const variantsRaw = wrapper.getAttribute('data-variants');
    if (!variantsRaw) return;
    let variants;
    try { variants = JSON.parse(variantsRaw); } catch (e) { return; }
    const form = wrapper.querySelector('form') || wrapper;
    const variantIdInput = form.querySelector('[name="id"]');
    const priceEl = document.querySelector('[data-pdp-price]');
    const priceOldEl = document.querySelector('[data-pdp-price-old]');
    const addBtn = form.querySelector('[data-pdp-add]');
    const addBtnText = addBtn?.querySelector('[data-pdp-add-text]');

    function currentSelection() {
      const picks = [];
      wrapper.querySelectorAll('[data-option-group]').forEach(group => {
        const active = group.querySelector('.pdp-variant-opt.active');
        picks.push(active ? active.getAttribute('data-value') : null);
      });
      return picks;
    }

    function resolveVariant() {
      const picks = currentSelection();
      return variants.find(v => {
        for (let i = 0; i < picks.length; i++) {
          if (picks[i] == null) return false;
          const optVal = v['option' + (i + 1)];
          if (optVal !== picks[i]) return false;
        }
        return true;
      });
    }

    function updateUI() {
      const variant = resolveVariant();
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; }
        if (addBtnText) addBtnText.textContent = 'Unavailable';
        return;
      }
      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = variant.price_formatted || priceEl.textContent;
      if (priceOldEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceOldEl.textContent = variant.compare_at_price_formatted || '';
          priceOldEl.style.display = '';
        } else {
          priceOldEl.style.display = 'none';
        }
      }
      if (addBtn) addBtn.disabled = !variant.available;
      if (addBtnText) addBtnText.textContent = variant.available ? 'Add to Bag' : 'Sold Out';
    }

    wrapper.querySelectorAll('[data-option-group]').forEach(group => {
      group.querySelectorAll('.pdp-variant-opt').forEach(opt => {
        opt.addEventListener('click', () => {
          group.querySelectorAll('.pdp-variant-opt').forEach(o => o.classList.remove('active'));
          opt.classList.add('active');
          updateUI();
        });
      });
    });

    updateUI();
  });
})();
